export default __webpack_public_path__ + "static/media/paso3.5c8018ce.png";